<script>
    import { onMount } from "svelte";

    // 所有设备代码
    let totalcount = 0;
    let devcodes = [];
    let deviceopts = [];
    let frmDevice = "";
    let frmDeviceSearch = "";
    let frmProperty = "lpos";
    let getValstr = "";
    let setValstr = "";

    // 提示框配置
    toastr.options = {
        positionClass: "toast-top-center",
    };

   // 加载事件函数
   onMount(() => {
        loadDevices();
    });

    function loadDevices() {
        let tmpUrl = "/rtapi/getdevlist";
        jQuery.ajax({
            type: "get",
            url: tmpUrl,
            success: function (response) {
                if (response.code == 200) {
                    if (Array.isArray(response.result)) {
                        devcodes = response.result;
                        totalcount = devcodes.length;
                    }
                }
            },
            error: function (err) {
                console.log(err);
            },
        });
    }

    function on_search_keyup(event) {
        if (event.keyCode == 13) {
            let tmpOpt = [];
            for (let i=0;i<devcodes.length;i++) {
                if (devcodes[i].includes(frmDeviceSearch)) {
                    tmpOpt.push(devcodes[i]);
                }
            }
            deviceopts = tmpOpt;
            if (deviceopts.length >0) {
                frmDevice = deviceopts[0];
            }
        }
    }

    function getRTValue() {
        let sKey = "IOTRT@" + frmDevice + "@" + frmProperty;
        let tmpUrl = "/rtapi/readsingledata?k=" + sKey;
        jQuery.ajax({
            type: "get",
            url: tmpUrl,
            success: function (response) {
                if (response.code == 200) {
                    getValstr = response.result;
                } else {
                    getValstr = "err";
                }
            },
            error: function (err) {
                getValstr = err;
            },
        });
    }

    function setRTValue() {
        // 校验输入值
        if (frmProperty == "lastupdate") {
            let reg = /^[1-9]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])\s+(20|21|22|23|[0-1]\d):[0-5]\d:[0-5]\d$/;
            if (!reg.test(setValstr)) {
                toastr.error("输入不符合日期格式");
                return;
            }
        } else {
            let reg = /^\d+(\.\d+)?$/ ;
            if (!reg.test(setValstr)) {
                toastr.error("输入不符合数字格式");
                return;
            }
        }
        if (frmDevice.trim() == "") {
            toastr.error("设备代码不能为空");
            return;
        }
        if (frmProperty.trim() == "") {
            toastr.error("参数不能为空");
            return;
        }
        // 写入后台
        let tmpUrl = "/rtapi/writertdatas";
        let reqprops = [];
        let keyprop = "IOTRT@" + frmDevice + "@" + frmProperty;
        let keyval = setValstr.toString();
        let rtdata = {rtkey: keyprop,rtval:keyval};
        reqprops.push(rtdata);
        jQuery.ajax({
            type: "post",
            url: tmpUrl,
            data: JSON.stringify(reqprops),
            success: function (response) {
                if (response.code == 200) {
                    toastr.info("实时数据写入成功");
                } else {
                    toastr.error("实时数据写入失败");
                }
            },
            error: function (err) {
                toastr.error("实时数据写入异常:" + err);
            }
        });
    }

</script>

<!-- Content Wrapper. Contains page content -->
<div class="content-wrapper">
    <!-- Content Header (Page header) -->
    <section class="content-header">
        <div class="container-fluid">
            <div class="row mb-2">
                <div class="col-sm-6">
                    <h1>修正工具</h1>
                </div>
                <div class="col-sm-6">
                    <ol class="breadcrumb float-sm-right">&nbsp;</ol>
                </div>
            </div>
        </div>
    </section>
    <!-- Main content -->
    <section class="content">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <!-- card -->
                    <div class="card">
                        <div class="card-header">
                            <h3 class="card-title">数值修正</h3>
                            <div class="card-tools">
                                &nbsp;
                            </div>
                        </div>
                        <div class="card-body" styel="height:400px">
                            <div class="form-group row">
                                <label for="frmDevice" class="col-sm-2 col-form-label">选择设备:</label>
                                <div class="col-sm-3">
                                    <select
                                        class="form-control"
                                        id="frmDevice"
                                        bind:value={frmDevice}
                                    >
                                        {#each deviceopts as opt}
                                        <option value={opt}>{opt}</option>
                                        {/each}
                                    </select>
                                </div>
                                <div class="col-sm-3">
                                    <input
                                        type="text"
                                        class="form-control"
                                        id="frmDeviceSearch"
                                        bind:value={frmDeviceSearch}
                                        placeholder="输入关键字+回车"
                                        on:keyup={on_search_keyup}
                                        title="输入检索词并回车"
                                    />
                                </div>
                                <div class="col-sm-4">&nbsp;</div>
                            </div>
                            <div class="form-group row">
                                <label for="frmProperty" class="col-sm-2 col-form-label">选择参数:</label>
                                <div class="col-sm-4">
                                    <select
                                        class="form-control"
                                        id="frmProperty"
                                        bind:value={frmProperty}
                                    >
                                        <option value="lpos">液位</option>
                                        <option value="ch4">甲烷</option>
                                        <option value="h2s">硫化氢</option>
                                        <option value="co">一氧化碳</option>
                                        <option value="lastupdate">更新时间</option>
                                    </select>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label for="frmProperty" class="col-sm-2 col-form-label">修正操作</label>
                                <div class="col-sm-10">
                                    <div class="row" style="padding-left:10px;padding-bottom:20px">
                                        <input type="search" bind:value={getValstr}  readonly=True style="width:300px"/>
                                        <button type="submit" class="btn btn-default" on:click={getRTValue}>
                                            <i class="bi bi-search"></i> 读取
                                        </button>
                                    </div>
                                    <div class="row" style="padding-left:10px;padding-bottom:20px">
                                        <input type="search" bind:value={setValstr} style="width:300px"/>
                                        <button type="submit" class="btn btn-default" on:click={setRTValue}>
                                            <i class="bi bi-search"></i> 写入
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- end of card -->
                </div>
            </div>
        </div>
    </section>
</div>

<style>
</style>
